module.exports = __webpack_public_path__ + "aa767c94df84bf6da1a3df069350555c.jpg";